/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Training_Settings_TitleInputs */

const en_training_settings_title = /** @type {(inputs: Training_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training settings`)
};

const pl_training_settings_title = /** @type {(inputs: Training_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawienia treningu`)
};

/**
* | output |
* | --- |
* | "Training settings" |
*
* @param {Training_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const training_settings_title = /** @type {((inputs?: Training_Settings_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Training_Settings_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_training_settings_title(inputs)
	return en_training_settings_title(inputs)
});